<template>
  <article class="inside relative flex flex-column">
    <div class="info-container flex flex-column order-2">
      <h3
        v-if="title"
        class="order-2"
      >
        <UILinkComponent
          :to="url"
          class="no-underline covering-link"
        >
          {{ title }}
        </UILinkComponent>
      </h3>
      <p
        v-if="subtitle"
        class="order-3 subtitle"
      >
        {{ subtitle }}
      </p>
      <div
        v-if="label || date"
        class="flex align-center order-1"
      >
        <span
          v-if="label"
          class="label mr-sm"
        >
          {{ label }}
        </span>
        <span v-if="date">
          {{ date }}
        </span>
      </div>
    </div>

    <div class="img-container order-1">
      <BaseImage
        v-if="imageObject"
        :media-object="imageObject"
        :sizes="{ sm: 420, md: 800 }"
      >
        <template #fallback>
          <div class="fallback" />
        </template>
      </BaseImage>
      <div
        v-else
        class="fallback"
      />
    </div>
  </article>
</template>

<script setup lang="ts">
  import type { ElocusMediaResponse } from '@tc8l/nuxt-base'

  defineProps<{
    title: string
    url?: string
    imageObject?: ElocusMediaResponse
    subtitle?: string
    label?: string
    date?: string
  }>()
</script>

<style lang="scss" scoped>
  .inside {
    position: relative;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    width: 100%;
    height: 100%;
    gap: var(--margin-lg);
    overflow: hidden;

    &:hover {
      .img-container {
        :deep(.ImageComponent) img {
          transform: scale(1.03);
        }
      }
    }
  }

  .info-container {
    width: 100%;
    gap: var(--margin-md);

    h3 {
      overflow-wrap: anywhere;
      @include line-clamp(3);
    }

    .subtitle {
      @include line-clamp(2);
    }
  }

  .img-container {
    position: relative;
    width: 100%;
    aspect-ratio: 19 / 16;
    height: auto;
    border-radius: var(--border-radius-lg);
    overflow: hidden;

    .fallback {
      background-color: $color-accent;
      width: 100%;
      height: 100%;
    }

    :deep(.ImageComponent) {
      width: 100%;
      height: 100%;
      overflow: hidden;

      .image-wrapper {
        width: 100%;
        height: 100%;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transform: translateZ(0) scale(1, 1);
          transition: transform var(--animation-duration) var(--ease-fast-in-slow-out);
        }
      }
    }
  }
</style>
